import {
  NEW_CANDIDATES_FETCHING,
  NEW_CANDIDATES_FAILED,
  NEW_CANDIDATES_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case NEW_CANDIDATES_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case NEW_CANDIDATES_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case NEW_CANDIDATES_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
